import {Button, Div, ImageView, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {navigate} from 'services';
import {useAppSelector} from 'store/hooks';

function HeaderBackType3() {
  const insests = useSafeAreaInsets();
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const {name, bankAccount, investmentProfile} = currentUser;
  const paddingTop = 40 + insests.top;
  return (
    <Div
      paddingTop={paddingTop}
      paddingBottom={9}
      paddingLeft={19}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      paddingRight={24}
      // backgroundColor={Ecolors.mainColor}
    >
      <Button
        onPress={() => {
          navigate('ProfileScreen');
        }}
        flexDirection={'row'}>
        <Div
          widthHeight={40}
          borderRadius={40}
          alignItems={'center'}
          justifyContent={'center'}
          backgroundColor={Ecolors.spaceColor}>
          <ImageView
            source={Icons.profile}
            tintColor={Ecolors.textColor}
            width={18}
            height={24}
            resizeMode={'contain'}
          />
        </Div>
        <Div
          paddingHorizontal={11}
          flexDirection={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}>
          <Div flex={1}>
            <Label
              size={16}
              numberOfLines={1}
              color={Ecolors.textColor}
              multilanguage={false}
              fontWeight={'500'}>
              {name?.toLocaleUpperCase() || '' || ''}
            </Label>
          </Div>

          <Div flexDirection={'row'} alignItems={'center'} flex={1}>
            <Label
              size={13}
              color={Ecolors.textColor}>{`profile.sotaikhoan`}</Label>
            <Label size={13} multilanguage={false} color={Ecolors.textColor}>
              {investmentProfile?.number || ''}
            </Label>
          </Div>
        </Div>
      </Button>
      {/* <Notification /> */}
    </Div>
  );
}

export default React.memo(HeaderBackType3);
